import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('UtilsDA', UtilsDA);

    UtilsDA.$inject = ['Restangular', 'LongTask', 'CONF'];

    /* @ngInject */
    function UtilsDA(Restangular, LongTask, CONF) {
        var version = 'v1';

        var exports = {
            getLongTaskDetails: getLongTaskDetails
        };

        return exports;

        ////////////////

        function getLongTaskDetails(longTaskId) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one('long-tasks', longTaskId)
                .get()
                .then(function(data) {
                    return new LongTask(data);
                });
        }
    }
})();
